import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    timezoneBox: {
      alignItems: 'center',
      backgroundColor: theme.palette.common.blazeOrange,
      border: theme.palette.border.warning,
      borderRadius: 4,
      color: theme.palette.text.subtitle,
      display: 'flex',
      fontSize: theme.typography.pxToRem(13),
      margin: '10px 0',
      padding: 10,
    },
    warningIcon: {
      color: theme.palette.warning.main,
      marginRight: 10,
    },
    checkboxLabel: {
      display: 'flex',
    },
    checkField: {
      marginLeft: '-0.75rem',
    },
  };
});

export { useStyles };
